import type React from 'react'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { API_URL } from '../../../../constants'
import { useGetAllLegacySwapsQuery } from '../../../../redux/services/coreApi'
import type { RootState } from '../../../../redux/store'
import type { SwapDto } from '../../../../types/coreApi-types'
import downloadSwapInvoice from '../../../../utils/downloadInvoice'
import Table from '../Broker Service/components/Table'

const LegacySwapsScreen: React.FC = () => {
  const { data: legacySwapInvoices, isLoading } = useGetAllLegacySwapsQuery()
  const [downloadingId, setDownloadingId] = useState<string | null>(null)
  const sessionToken = useSelector((state: RootState) => state.session.token)

  // Extract SwapDto from SwapInvoiceDto[] for the Table component
  const legacySwaps = legacySwapInvoices?.map(invoice => invoice.swap) || []

  const handleDownloadInvoice = async (swap: SwapDto) => {
    if (!sessionToken) return

    setDownloadingId(swap.id)
    try {
      await downloadSwapInvoice(
        swap,
        sessionToken,
        `${API_URL}/swaps/legacy/${swap.id}/invoice`
      )
    } catch (error) {
      // Error handling could be improved with toast notifications
    } finally {
      setDownloadingId(null)
    }
  }

  return (
    <div className="w-full">
      <div className="mb-6">
        <h2 className="text-xl font-semibold text-brand-light-text dark:text-brand-dark-text mb-2">
          Legacy Swaps
        </h2>
        <p className="text-sm text-brand-light-text-secondary dark:text-brand-dark-text-secondary">
          We use your current account email address to match up with previous
          swaps created.
          <br />
          If you have changed your email address and want to download an invoice
          associated with your other account, please contact support.
        </p>
      </div>

      <Table
        swaps={legacySwaps}
        isLoading={isLoading}
        disableStatusModal={true}
        onDownloadInvoice={handleDownloadInvoice}
        downloadingId={downloadingId}
      />
    </div>
  )
}

export default LegacySwapsScreen
